import { Observable, Subject, BehaviorSubject } from "rxjs";
import ApiService from "lib/services/ApiService";

export class Bucket {
  state$ = new BehaviorSubject(null);
  events$ = new Subject();

  constructor(name, payload) {
    this.name = name;
    this.payload = payload;
  }

  get state() {
    return this.state$.getValue();
  }
}

export class BucketsStore {
  buckets = new Map();

  static getBucketKey(name, payload = {}) {
    return `${name}?${JSON.stringify(payload)}`;
  }

  findOrInitialize(name, payload) {
    const bucketKey = this.constructor.getBucketKey(name, payload);
    let bucket = this.buckets.get(bucketKey);
    if (!bucket) {
      bucket = new Bucket(name, payload);
      this.buckets.set(bucketKey, bucket);
    }
    return bucket;
  }
}

export default class BaseRepository {
  api = ApiService;
  buckets = new BucketsStore();

  getBucket(name, payload = {}) {
    return this.buckets.findOrInitialize(name, {
      ...payload,
      current_admin_user_email: this.api.currentAdminUserEmail,
      current_company_id: this.api.currentCompanyId,
    });
  }

  attachRequestToBucket(bucket) {
    return (request) => {
      return request.let(this.updateBucketStateWithRequest(bucket)).let(this.publishRequestEventsOnBucket(bucket));
    };
  }

  updateBucketStateWithRequest(bucket) {
    return (request) => {
      return request.do((data) => {
        bucket.state$.next(data);
      });
    };
  }

  publishRequestEventsOnBucket(bucket) {
    return (request) => {
      bucket.events$.next({ type: "FETCH_LOADING" });
      return request.do(
        (data) => {
          bucket.events$.next({ type: "FETCH_SUCCESS", data });
        },
        (error) => {
          bucket.events$.next({ type: "FETCH_FAILURE", error });
        },
        () => {
          bucket.events$.next({ type: "FETCH_COMPLETE" });
        }
      );
    };
  }

  mergeRequestWithCurrentBucketState(bucket, request$) {
    request$ = request$.let(this.attachRequestToBucket(bucket));
    return bucket.state !== null ? request$.merge(Observable.of(bucket.state).delay(0)) : request$;
  }
}



// WEBPACK FOOTER //
// ./src/lib/repositories/BaseRepository.js